module.exports = __webpack_public_path__ + "static/media/full.0c1f922f.png";